export enum EnumChometzSaleResponseMode {
    None,
    OUDirect,
    JotForm,
    Kashrus
}